import React, { useState } from "react";
import styles from "./Card.module.scss";
import { encodeBase64 } from "util/helper";

export function PublisherCard({
  itemId,
  selected,
  onClick,
  data,
  history,
  level,
}) {
  const [imageExists, setImageExists] = useState(true);

  const defaultImg =
    "https://exambank.s3.ap-southeast-1.amazonaws.com/images/publisher/logo-1701146973885.png";

  const goToPublisher = () => {
    const id = encodeBase64(
      `${data.name} ${data.info ? data.info : ""};${data.id}`
    );
    history.push(`/publisher/${id}`, {
      level: level,
      publisherId: data.id,
      publisherName: data.name,
    });
  };

  const handleImageError = () => {
    setImageExists(false);
  };

  return (
    <div role="button" tabIndex={0} className={styles.card}>
      <div className={styles.logo} onClick={() => goToPublisher(data.name)}>
        {imageExists ? (
          <img
            src={data.logo}
            alt="logo"
            className={styles.logoImg}
            onError={handleImageError}
          />
        ) : (
          <img src={defaultImg} alt="logo" className={styles.logoImg} />
        )}
      </div>
      <div className={styles.publisher}>{data.name}</div>
    </div>
  );
}
